import { Image } from "react-bootstrap";

import imageNotFound from "../../../../assets/img/imageNotFound.png";

const tableColumns = [
  {
    id: "image",
    Header: "Item Image",
    accessor: (row) => {
      const image = row.imageUrl ? row.imageUrl : null;
      return (
        <Image
          thumbnail
          style={{ maxHeight: "75px" }}
          src={image ? image : imageNotFound}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = imageNotFound;
          }}
        />
      );
    },
  },
  {
    Header: "ASIN",
    accessor: "asin",
  },
  {
    Header: "Title",
    accessor: "title",
    Cell: ({ value }) => (
      <div
        style={{
          maxHeight: "3.6em", // Adjust the value to control the number of lines before ellipsis
          lineHeight: "1.2em", // Adjust the line height for proper spacing
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 3, // Adjust the number of lines to show before ellipsis
          WebkitBoxOrient: "vertical",
        }}
      >
        {value}
      </div>
    ),
  },

  {
    Header: "FNSKU",
    accessor: "fnsku",
  },
  {
    Header: "SKU",
    accessor: "sku",
  },
];

export default tableColumns;
